import { BehaviorSubject } from 'rxjs';

import config from 'config';
import configData from "./../config.json";
import { object } from 'prop-types';
import { RemoveLocalStorageElementsModalActualizarDP, RemoveLocalStorageMensajeMarcacion } from 'functions/LocalStorageFunctions';
import { setCookie } from 'functions/CookiesFunctions';
import { msalInstance } from 'helpers/EntraID/msalInstance';

const API_URL = configData.SERVER_URL
const currentUser = {
    usuario: "",
    idpersona: 0,
    identificacion: "",
    apellidos: "",
    nombres: "",
    genero: "",
    ultimoCambio: "",
    roles: [],
    token: "",
    roles_usuario: [],
    regimen_usuario: [],
    periodo_planificacion_vac_activo: false,
    tipo_director_unidad: "N/A",
    showModalActualizarDP: false,
    soloTieneContratoESPOLTECH: false,
    soloTieneSolicitudContratacion: false,
    estructuraOrganicaConsultor: 0,
    estadosDesvinculacion: [],
    ultimoCambioDatosPersonales: "",
    referenciaFotoWeb: "",
    fechaHoraSesionActiva: undefined,
    fechaHoraSesionComparar: undefined,
    tieneHorarioJornadaEspecial: false
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
    updateCurrentUserValue(userValue) { currentUserSubject.next(userValue) },
    updateUltimoCambioCurrentUserValue,
    UpdateSessionTime,
    UpdateSessionCompareTime

};

function updateUltimoCambioCurrentUserValue(fechaDeseada) {
    var valorActual = currentUserSubject.value;
    valorActual = { ...valorActual, ultimoCambio: fechaDeseada }
    currentUserSubject.next(valorActual);
}

// async function login() {
//     let currentUser = null;
//     const response = await fetch('/Account/GetUser')
//     const data = await response.json()
//     if (data && data.strEstado == "S") {
//         currentUser = {
//             usuario: data.token.username,
//             idpersona: data.persona.idpersona,
//             identificacion: data.persona.numeroidentificacion,
//             apellidos: data.persona.apellidos,
//             nombres: data.persona.nombres,
//             genero: data.persona.genero,
//             ultimoCambio: data.persona.ultimocambio,
//             roles: data.token.roles.split(";"),
//             token: data.token.tokenth,
//             roles_usuario:data.rolesusuarios,
//             regimen_usuario:data.regimenusuario,
//             periodo_planificacion_vac_activo:data.periodoPlanifVacacionesActivo,
//             tipo_director_unidad: data.tipoDirectorUnidad,
//             showModalActualizarDP:data.showModalActualizarDP,
//             soloTieneContratoESPOLTECH: data.soloTieneContratoESPOLTECH,
//             soloTieneSolicitudContratacion : data.soloTieneSolicitudContratacion,
//             estructuraOrganicaConsultor: data.estructuraOrganicaConsultor,
//             estadosDesvinculacion:data.estadosDesvinculacion,
//             ultimoCambioDatosPersonales:data.ultimoCambioDatosPersonales,
//             referenciaFotoWeb:data.referenciaFotoWeb,
//             fechaHoraSesionActiva:data.fechaHoraSesionActiva,
//             fechaHoraSesionComparar:data.fechaHoraSesionComparar,
//             tieneHorarioJornadaEspecial:data.tieneHorarioJornadaEspecial,

//         }



//         let realFetch = window.fetch;
//         window.fetch = function (url, opts = null) {
//             if (currentUser.token && url.indexOf("imgEmpleado") < 0) {
//                 opts = Object.assign({}, opts, { 'headers': { 'Authorization': `KEYESPOL ${currentUser.token}` } });
//                 if (url.indexOf("Files") < 0 && url.indexOf("Refarchivo") < 0) {
//                     opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `KEYESPOL ${currentUser.token}` } });
//                 }
//                 //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
//                 return realFetch(url, opts);
//             } else {
//                 //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
//                 return realFetch(url, opts);
//             }
//         };
//         //console.log("token = " + JSON.stringify(data.token.tokenth));
//         currentUserSubject.next(currentUser);
//     }
//     currentUserSubject.next(currentUser);
//     return currentUser;
// }

async function login(user) {
    let currentUser = null;
    const response = await fetch('/Account/GetUser/' + user)
    const data = await response.json()
    if (data && data.strEstado == "S") {
        currentUser = {
            usuario: data.token.username,
            idpersona: data.persona.idpersona,
            identificacion: data.persona.numeroidentificacion,
            apellidos: data.persona.apellidos,
            nombres: data.persona.nombres,
            genero: data.persona.genero,
            ultimoCambio: data.persona.ultimocambio,
            roles: data.token.roles.split(";"),
            token: data.token.tokenth,
            roles_usuario: data.rolesusuarios,
            regimen_usuario: data.regimenusuario,
            periodo_planificacion_vac_activo: data.periodoPlanifVacacionesActivo,
            tipo_director_unidad: data.tipoDirectorUnidad,
            showModalActualizarDP: data.showModalActualizarDP,
            soloTieneContratoESPOLTECH: data.soloTieneContratoESPOLTECH,
            soloTieneSolicitudContratacion: data.soloTieneSolicitudContratacion,
            estructuraOrganicaConsultor: data.estructuraOrganicaConsultor,
            estadosDesvinculacion: data.estadosDesvinculacion,
            ultimoCambioDatosPersonales: data.ultimoCambioDatosPersonales,
            referenciaFotoWeb: data.referenciaFotoWeb,
            fechaHoraSesionActiva: data.fechaHoraSesionActiva,
            fechaHoraSesionComparar: data.fechaHoraSesionComparar,
            tieneHorarioJornadaEspecial: data.tieneHorarioJornadaEspecial,

        }



        let realFetch = window.fetch;
        window.fetch = function (url, opts = null) {
            if (currentUser.token && url.indexOf("imgEmpleado") < 0) {
                opts = Object.assign({}, opts, { 'headers': { 'Authorization': `KEYESPOL ${currentUser.token}` } });
                if (url.indexOf("Files") < 0 && url.indexOf("Refarchivo") < 0) {
                    opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `KEYESPOL ${currentUser.token}` } });
                }
                //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
                return realFetch(url, opts);
            } else {
                //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
                return realFetch(url, opts);
            }
        };
        //console.log("token = " + JSON.stringify(data.token.tokenth));
        currentUserSubject.next(currentUser);
    }
    currentUserSubject.next(currentUser);
    return currentUser;
}

function UpdateSessionTime(tiempoSession, tiempoComparar) {
    var valorActual = currentUserSubject.value;
    valorActual = { ...valorActual, fechaHoraSesionActiva: tiempoSession, fechaHoraSesionComparar: tiempoComparar }
    currentUserSubject.next(valorActual);

}

function UpdateSessionCompareTime(tiempoComparar) {
    var valorActual = currentUserSubject.value;
    valorActual = { ...valorActual, fechaHoraSesionComparar: tiempoComparar }
    currentUserSubject.next(valorActual);

}

function logout() {
    // remove user and go to logout CAS
    // currentUserSubject.next(null);
    // window.location = "/Account/Logout";
    RemoveLocalStorageElementsModalActualizarDP();
    RemoveLocalStorageMensajeMarcacion();
    currentUserSubject.next(null);
    msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/",
    });


}
